import {createAsyncThunk} from "@reduxjs/toolkit";

import {
    getRoles as getRolApi, createRoles as createRolesApi, updateRoles as updateRolesApi, deleteRoles as deleteUserApi
} from "./api";
import 'react-toastify/dist/ReactToastify.css';
import {toast} from "react-toastify";


export const getRol = createAsyncThunk("roles/getRoles", async () => {
    try {
        return await getRolApi();
    } catch (error) {
        return error;
    }
})

export const addRol = createAsyncThunk("roles/addRol", async (roles: any) => {
    try {
        const response = createRolesApi(roles);
        const data = await response;
        toast.success("Rol creado", {autoClose: 3000});
        return data;
    } catch (error) {
        toast.error("Ocurrio un error en crear el rol", {autoClose: 3000});
        return error;
    }
});

export const updateRol = createAsyncThunk("roles/update", async (roles: any) => {

    console.log("Roles ", roles)
    try {
        const response = updateRolesApi(roles);
        const data = await response;
        toast.success("El rol se actualizo correctamente", {autoClose: 3000});
        return data;
    } catch (error) {
        toast.error("Ocurrio un error al actualizar el rol", {autoClose: 3000});
        return error;
    }
});

export const deleteRol = createAsyncThunk("roles/deleteRol", async (id: any) => {
    try {
        const response = deleteUserApi(id);
        toast.success("El rol ha sido eliminado con éxito", {autoClose: 2000});
        return {id, ...response};
    } catch (error) {
        toast.error("Ocurrio un error al eliminar el rol", {autoClose: 2000});
        return error;
    }

});

